export const SET_STEP_INDEX = 'SET_STEP_INDEX'
export const SET_GUIDE_VISIBLE = 'SET_GUIDE_VISIBLE'
export const SET_STAGE_INDEX = 'SET_STAGE_INDEX'
export const SET_ONBOARDING_INITIAL_DATA = "SET_ONBOARDING_INITIAL_DATA"
export const SET_ONBOARING_APP_DETAILS = "SET_ONBOARING_APP_DETAILS"
export const SET_STEPS = "SET_STEPS"
export const UPDATE_INITIAL_ONBOARDING_DATA = "UPDATE_INITIAL_ONBOARDING_DATA"
export const SET_IS_DRAG = "SET_IS_DRAG"
export const CLEAR_ONBOARDING = "CLEAR_ONBOARDING"
export const SET_SERVICE_TASK_EXIST = 'SET_SERVICE_TASK_EXIST'
export interface IOnboarding {
    guideVisible: boolean,
    steps?: any[],
    appDetails: any,
    info: any,
    isDrag: boolean,
    loading: boolean,
    isExistServiceTask: boolean
}

interface CurrentRouteAction {
    type: typeof SET_STEP_INDEX | 
    typeof SET_GUIDE_VISIBLE | 
    typeof SET_STAGE_INDEX | 
    typeof SET_ONBOARDING_INITIAL_DATA |
    typeof SET_ONBOARING_APP_DETAILS |
    typeof SET_STEPS |
    typeof UPDATE_INITIAL_ONBOARDING_DATA |
    typeof SET_IS_DRAG  | 
    typeof CLEAR_ONBOARDING | 
    typeof SET_SERVICE_TASK_EXIST
    payload: any
}


export type CurrentRouteActionTypes = CurrentRouteAction;